<div
  (click)="redirectToDailyReport(dailyReport)"
  class="wrapper w-[580px] mb-[20px] cursor-pointer"
  >
  <div class="header-section flex gap-[12px] w-full">
    <div class="left w-[48px]">
      <div class="icon-holder flex justify-center items-center">
        <mat-icon [svgIcon]="icon" class="icon" />
      </div>
    </div>
    <div class="right min-w-0 grow">
      <div class="daily-report-heading text-type-6 !leading-[24px]">
        {{ dailyReport?.report_date | date:'longDate' }}
      </div>
      <div class="daily-report-sub-heading text-type-14 !text-[#060b1e]">
        {{ dailyReport?.project?.name }},{{ dailyReport?.site?.name }}
        . {{ dailyReport?.created_by?.first_name }} {{ dailyReport?.created_by?.last_name }}
      </div>
      <div class="match-info text-type-14">
        {{ dailyReport?.summary?.matches }} matches @if (componentsList) {
        <span>({{ componentsList }})</span>
      }
      </div>
      @if (matchedHintHtml) {
        <div [innerHTML]="matchedHintHtml" class="matched-hint text-type-14">
        </div>
      }
    </div>
  </div>
</div>
